import React, { useState, useEffect } from 'react'
import LayoutSingleView from '../common/layout/LayoutSingleView'
import { MenuItems } from '../../enums/MenuItems'
import Section from '../common/sections/Section'
import Cards from '../common/cards/Cards'
import kitApi, { type ScreenerListItemUserDto } from '../../api/kit/KitApi'
import ScreenerCard from './components/ScreenerCard'

export default function JobScreenersList(): React.JSX.Element {
    const [screeners, setScreeners] = useState<ScreenerListItemUserDto[]>([])
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        async function load() {
            try {
                setIsLoading(true)
                const res = await kitApi.getScreenersForUser()
                setScreeners(res.screeners)
            } catch {
                setError('Unable to load screeners.')
            } finally {
                setIsLoading(false)
            }
        }
        void load()
    }, [])

    return (
        <LayoutSingleView activeMenuItem={MenuItems.JobScreeners}>
            <Section title="Job Screeners" titleType="h2">
                {isLoading ? (
                    <div className="flex justify-center py-12">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-ctxt-blue" />
                    </div>
                ) : error ? (
                    <div className="text-center py-12 text-red-500">
                        <p className="text-sm font-medium">{error}</p>
                    </div>
                ) : screeners.length === 0 ? (
                    <div className="text-center py-12 text-gray-400">
                        <p className="text-lg font-medium">No screeners yet</p>
                    </div>
                ) : (
                    <Cards>
                        {screeners.map((screener) => (
                            <ScreenerCard
                                key={screener.id}
                                screener={screener}
                            />
                        ))}
                    </Cards>
                )}
            </Section>
        </LayoutSingleView>
    )
}
